module.exports = __webpack_public_path__ + "media/images/515151ne-b8ea9ff16c76ca868444918e791d3922.png";